"use client";
import React, { useState, useEffect, useCallback } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
  height: "300px",
  width: "100%",
};

function NhMapContainer({ lat, lng }) {
  const [isMarkerShown, setIsMarkerShown] = useState(false);
  const [mapCenter, setMapCenter] = useState({
    lat: lat ? parseFloat(lat) : 16.989065,
    lng: lng ? parseFloat(lng) : 82.247467,
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMarkerShown(true);
      if (lat && lng) {
        setMapCenter({
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        });
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [lat, lng]);

  const handleMarkerClick = useCallback(() => {
    setIsMarkerShown(false);
    setTimeout(() => {
      setIsMarkerShown(true);
    }, 5000);
  }, []);

  return (
    <LoadScript
      googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_API}
      libraries={["geometry", "drawing", "places"]}
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapCenter}
        zoom={12}
      >
        {isMarkerShown && (
          <Marker position={mapCenter} onClick={handleMarkerClick} />
        )}
      </GoogleMap>
    </LoadScript>
  );
}

export default NhMapContainer;
